export default "__VITE_ASSET__D$Rm5xrL__"